/* eslint-disable import/prefer-default-export */
import moment from 'moment';

export const formatDate = (s: string, format: string) => moment(s).format(format);
